export default __webpack_public_path__ + "static/media/fasting_hunger@3x.900e0130.jpg";